import {requestContext} from '../../common/requestContext';
import {ContentProductListParam} from '../../common/shared/api/nicolas/params/ContentProductListParam.interface';
import {CursorDirectionVo} from '../../common/shared/api/nicolas/vo/enums/CursorDirectionVo.enum';
import {ContentHomeProductListQueryVariables} from '../../graphql/generated/types';

export const getContentHomeProductListParam = (
  variables: ContentHomeProductListQueryVariables
): ContentProductListParam => {
  const {before, first, last, after, seriesId, boughtOnly, sortType} =
    variables;
  const isMobile = requestContext.requestInfo.display.isMobile;

  const cursor_direction =
    after !== undefined
      ? CursorDirectionVo.NEXT
      : before !== undefined
        ? CursorDirectionVo.PREV
        : // sortType 이 있으면 반드시 INIT 이 아니여야함. INIT 이면 무시됨.
          sortType !== undefined
          ? CursorDirectionVo.NEXT
          : CursorDirectionVo.INIT;

  const contentProductListParam: ContentProductListParam = {
    series_id: seriesId,
    cursor_index: Number(before ?? after ?? 0),
    // PC에서 기존 앵커링 동작을 유지하기 위해 INIT일 경우 ANCHOR로 direction을 변경해줍니다.
    cursor_direction:
      cursor_direction === CursorDirectionVo.INIT && !isMobile
        ? CursorDirectionVo.ANCHOR
        : cursor_direction,
    window_size:
      (cursor_direction === CursorDirectionVo.INIT && !isMobile // PC 는 콘텐츠홈에 걸려있는데 최초엔 6개만 보여줌
        ? 6
        : cursor_direction === CursorDirectionVo.PREV
          ? last
          : first) || 25,
    ...(boughtOnly && {bought_only: boughtOnly}),
    ...(sortType && {sort_type: sortType}),
  };
  return contentProductListParam;
};
